import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  IconButton,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import DeleteIcon from '@material-ui/icons/Delete';

import './index.scss';

class Form extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openAlert: false,
      rooms: [{
        room_name: '',
        rows: '',
        columns: '',
        invigilator: ''
      }],
      date: '',
      time: '',
      duration: '',
      examCenter: props.appData.examCenter,
      level: '',
      program: '',
      semester: '',
      subject: '',
      subjectCode: ''
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.addRoom = this.addRoom.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }
  
  handleClose = () => {
    this.setState({ openAlert: false })
  }

  handleSubmit = event => {
    event.preventDefault()

    if (this.props.students.length) {
      this.props.onSubmit(this.state)
    } else {
      this.setState({ openAlert: true })
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleTableDataChange(i, event) {
    let rooms = [...this.state.rooms];
    rooms[i][event.target.name] = event.target.value
    this.setState({ rooms });
  }

  addRoom = () => {
    this.setState(prevState => ({ rooms: [...prevState.rooms, {
      room_name: '',
      rows: '',
      columns: '',
      invigilator: ''
    }] }))
  }

  removeRoom = i => {
    let rooms = [...this.state.rooms];
    rooms.splice(i, 1);
    this.setState({ rooms });
  }

  renderTable = () => {
    return (
      <div className="room-container">
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Room Name</TableCell>
              <TableCell>Rows</TableCell>
              <TableCell>Columns</TableCell>
              <TableCell>Invigilator</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.renderRows()}
          </TableBody>
        </Table>
      </div>
    )
  }

  renderRows = () => {
    const { rooms } = this.state
    
    return rooms.map((r, i) => {
      const room = this.state.rooms[i]
      return (
        <TableRow key={i}>
          <TableCell>
            <TextField
              name="room_name" margin="dense" fullWidth
              onChange={this.handleTableDataChange.bind(this, i)}
              value={room.room_name} required
            />
          </TableCell>
          <TableCell>
            <TextField
              name="rows" type="number" margin="dense" fullWidth
              InputProps={{ inputProps: { min: 1, max: 22 } }}
              onChange={this.handleTableDataChange.bind(this, i)}
              value={room.rows} required
            />
          </TableCell>
          <TableCell>
            <TextField
              name="columns" type="number" margin="dense" fullWidth
              InputProps={{ inputProps: { min: 1, max: 8 } }}
              onChange={this.handleTableDataChange.bind(this, i)}
              value={room.columns} required
            />
          </TableCell>
          <TableCell>
            <TextField
              name="invigilator" margin="dense" fullWidth
              onChange={this.handleTableDataChange.bind(this, i)}
              value={room.invigilator} required
            />
          </TableCell>
          <TableCell>
            {
              (i) ? (
                <IconButton color="secondary" aria-label="delete" onClick={this.removeRoom.bind(this, i)}>
                  <DeleteIcon />
                </IconButton>
              ) : (<React.Fragment/>)
            }
          </TableCell>
        </TableRow>
      )
    })
  }

  renderAttendanceForm = () => {
    const { date, time, duration, examCenter, level, program, semester, subject, subjectCode } = this.state
    const { appData } = this.props
    const semesters = appData.semesters

    return (
      <div className="attendance-info-container">
        <Grid container spacing={3}>
          <Grid item xs={2}>
            <TextField
              name="date" margin="dense" label="Date" fullWidth
              onChange={this.handleChange}
              InputLabelProps={{ shrink: true, required: true }}
              value={date} required type="date"
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              name="time" margin="dense" label="Time" fullWidth
              onChange={this.handleChange}
              InputLabelProps={{ shrink: true, required: true }}
              value={time} required type="time"
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              name="duration" margin="dense" label="Duration" fullWidth
              onChange={this.handleChange}
              value={duration} required
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="examCenter" margin="dense" label="Exam Center" fullWidth
              // onChange={this.handleChange}
              value={examCenter} required disabled
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="level" margin="dense" label="Level" fullWidth
              onChange={this.handleChange}
              value={level} required
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="program" margin="dense" label="Programme" fullWidth
              onChange={this.handleChange}
              value={program} required
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="semester" margin="dense" label="Year/Semester" fullWidth
              id="standard-select-semester"
              helperText="Please select year/semester"
              onChange={this.handleChange}
              value={semester} required select
            >
              {semesters.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="subject" margin="dense" label="Subject" fullWidth
              onChange={this.handleChange}
              value={subject} required
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="subjectCode" margin="dense" label="Subject Code" fullWidth
              onChange={this.handleChange}
              value={subjectCode} required
            />
          </Grid>
        </Grid>
      </div>
    )
  }

  renderAlertDialog = () => {
    console.log('>>> openAlert', this.state.openAlert)

    return (
      <Dialog
        open={this.state.openAlert}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">ERROR</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please upload the excel whith student details to proceed.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  render = () => {
    const { students } = this.props
    console.log('>>> students', students)

    return (
      <div className="form-wrapper">
        <form onSubmit={this.handleSubmit}>
          {this.renderAttendanceForm()}
          {this.renderTable()}
          <div className="action-container">
            <Button type="button" variant="contained" color="secondary" onClick={this.addRoom}>
              <AddIcon />
              Add Room
            </Button>
            <Button type="submit" variant="contained" color="primary">Generate Report</Button>
          </div>
        </form>
        { this.renderAlertDialog() }
      </div>
    )
  }
}

Form.propTypes = {
  onSubmit: PropTypes.func,
  appData: PropTypes.object,
  students: PropTypes.array
}

export default Form
